import { render, staticRenderFns } from "./GovernateInfo.vue?vue&type=template&id=3057aaeb&scoped=true&"
import script from "./GovernateInfo.vue?vue&type=script&lang=js&"
export * from "./GovernateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3057aaeb",
  null
  
)

export default component.exports